import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, renderSlot as _renderSlot, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/plus.svg'
import _imports_1 from '@/app/ui/assets/svg/x-circle-outline.svg'
import _imports_2 from '@/app/ui/assets/svg/check-circle-border-green.svg'
import _imports_3 from '@/app/ui/assets/svg/pencil-alt.svg'
import _imports_4 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-1bcdbadc")

_pushScopeId("data-v-1bcdbadc")
const _hoisted_1 = { class: "w-full inline-block relative bottom-0 left-0 text-12px xxl:text-14px" }
const _hoisted_2 = { class: "flex flex-row items-center" }
const _hoisted_3 = { class: "px-3" }
const _hoisted_4 = {
  key: 0,
  class: "text-12px text-gray-lp-600"
}
const _hoisted_5 = { class: "inline-block relative w-full pr-8" }
const _hoisted_6 = { class: "w-full z-30 bg-white absolute border border-t-0 border-gray-lp-400 pr-1 rounded-b-md" }
const _hoisted_7 = {
  key: 0,
  class: "p-2"
}
const _hoisted_8 = {
  key: 1,
  class: "py-4 mb-2 text-gray-lp-300 text-center items-center"
}
const _hoisted_9 = {
  key: 2,
  class: "select overflow-auto",
  style: {"max-height":"100px"}
}
const _hoisted_10 = {
  key: 0,
  class: "flex-grow-0"
}
const _hoisted_11 = {
  key: 3,
  class: "px-4 py-3 border-t"
}
const _hoisted_12 = { class: "gap-x-2 justify-center items-center flex" }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "plus"
}, null, -1)
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "w-3/12" }, "Nama Driver", -1)
const _hoisted_16 = { class: "flex w-2/12" }
const _hoisted_17 = { class: "flex items-center mt-2" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "w-3/12" }, "No. Telp Driver", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_20 = {
  key: 1,
  class: "flex items-center justify-between"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "w-2/12" }, "No. Seri", -1)
const _hoisted_22 = { class: "inline-flex gap-x-2 ml-2 w-1/12" }
const _hoisted_23 = {
  key: 4,
  class: "px-4 py-3 border-t"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "gap-x-2 justify-center items-center flex" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "plus"
  }),
  /*#__PURE__*/_createTextVNode(" Tambah Rekening Bank ")
], -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "gap-x-2 justify-center items-center flex" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_3,
    alt: "edit"
  }),
  /*#__PURE__*/_createTextVNode(" Edit No. Rekening ")
], -1)
const _hoisted_26 = {
  key: 0,
  class: "text-12px text-red-lp-1000 mt-2"
}
const _hoisted_27 = {
  key: 0,
  src: _imports_4,
  class: "w-4.5 max-w-none",
  alt: "warning"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: 
          `w-full ${
            _ctx.isOpenMenu && !_ctx.isDisabled && _ctx.isShowErrorMessage
              ? 'border-l border-t rounded-t'
              : 'border-l border-t border-b rounded-l-md'
          } ${
            !_ctx.isLoading && _ctx.isShowErrorIndicator
              ? 'border-red-lp-1000'
              : 'border-gray-lp-400'
          } text-black-lp-300 py-1.5`
        
      }, [
        _createVNode("div", _hoisted_3, [
          (_ctx.titleInside)
            ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.titleInside), 1))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_5, [
            _createVNode("input", {
              maxlength: _ctx.maxLength,
              ref: "selectSearch",
              value: _ctx.filterSearch,
              onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args))),
              onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
              placeholder: _ctx.placeholder,
              class: 
                `w-full bg-white leading-tight py-1 font-normal focus:outline-none ${
                  _ctx.isDisabled
                    ? 'text-gray-lp-600 cursor-not-allowed'
                    : 'text-black-lp-300'
                }`
              ,
              disabled: _ctx.isDisabled,
              autocomplete: "nope"
            }, null, 42, ["maxlength", "value", "placeholder", "disabled"])
          ])
        ])
      ], 2),
      _createVNode("div", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSearchFilter && _ctx.onSearchFilter(...args))),
        class: 
          `bg-gray-lp-700 rounded-r-md ${
            _ctx.isDisabled
              ? 'text-gray-lp-600 cursor-not-allowed'
              : 'text-black-lp-300 cursor-pointer'
          } text-center my-1.5 border outline-none focus:shadow items-center py-2 xxl:py-3 text-14px px-3`
        
      }, " CARI ", 2)
    ]),
    _withDirectives(_createVNode("div", _hoisted_6, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode(_component_Skeleton, {
              height: "1.3rem",
              width: "88%",
              class: "my-2"
            }),
            _createVNode(_component_Skeleton, {
              height: "1.3rem",
              width: "94%",
              class: "my-2"
            }),
            _createVNode(_component_Skeleton, {
              height: "1.3rem",
              width: "83%",
              class: "my-2"
            }),
            _createVNode(_component_Skeleton, {
              height: "1.3rem",
              width: "97%",
              class: "my-2"
            })
          ]))
        : (_ctx.dataOptions.length === 0 && _ctx.isShowErrorMessage)
          ? (_openBlock(), _createBlock("div", _hoisted_8, " Apa yang Anda cari tidak ditemukan atau tidak ada. "))
          : (_openBlock(), _createBlock("div", _hoisted_9, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataOptions, (item, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: index,
                  class: 
            `cursor-pointer flex flex-row items-center px-4 py-1 hover:bg-gray-lp-700 ${index ===
              _ctx.dataOptions.length - 1 && 'pb-2'} ${
              _ctx.isSelected(item) ? 'text-red-lp-100' : 'text-black-lp-200'
            }`
          ,
                  onMousedown: ($event: any) => (_ctx.onChooseSelect(item))
                }, [
                  _createVNode("span", {
                    class: `flex-grow ${_ctx.secondKeyName && `truncate pr-1`}`
                  }, _toDisplayString(item[_ctx.keyName] || item), 3),
                  (_ctx.secondKeyName && item[_ctx.secondKeyName])
                    ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(item[_ctx.secondKeyName]), 1))
                    : _createCommentVNode("", true)
                ], 42, ["onMousedown"]))
              }), 128))
            ])),
      (_ctx.addDriver || _ctx.addLicensePlate)
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            _withDirectives(_createVNode("div", null, [
              _createVNode("button", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleOpenPlus(true))),
                style: {"border-color":"#d4d5d8"},
                class: "border rounded-lg py-2 px-3 text-black-lp-300 cursor-pointer focus:outline-none"
              }, [
                _createVNode("span", _hoisted_12, [
                  _hoisted_13,
                  _createTextVNode(" " + _toDisplayString(_ctx.addDriver ? "Tambah Driver" : "Tambah No. Seri Kendaraan"), 1)
                ])
              ])
            ], 512), [
              [_vShow, !_ctx.openPlus]
            ]),
            _withDirectives(_createVNode("div", null, [
              (_ctx.addDriver)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _withDirectives(_createVNode("input", {
                        onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.filterInputDriverName && _ctx.filterInputDriverName(...args))),
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.driver.name = $event)),
                        class: "text-gray-lp-500 w-7/12 p-1.5 bg-white border border-gray-lp-400 rounded shadow-xs leading-tight focus:outline-none",
                        placeholder: "Masukan nama driver",
                        type: "text"
                      }, null, 544), [
                        [_vModelText, _ctx.driver.name]
                      ]),
                      _createVNode("div", _hoisted_16, [
                        _createVNode("img", {
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clearDriverForm && _ctx.clearDriverForm(...args))),
                          class: "cursor-pointer mx-3",
                          style: {"height":"20px","width":"20px"},
                          src: _imports_1,
                          alt: "x"
                        }),
                        _createVNode("img", {
                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.submitDriver && _ctx.submitDriver(...args))),
                          class: "cursor-pointer",
                          style: {"height":"20px","width":"20px"},
                          src: _imports_2,
                          alt: "ok"
                        })
                      ])
                    ]),
                    _createVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _withDirectives(_createVNode("input", {
                        onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.filterInputDriverPhone && _ctx.filterInputDriverPhone(...args))),
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.driver.phone = $event)),
                        class: "text-gray-lp-500 w-7/12 p-1.5 bg-white border border-gray-lp-400 rounded shadow-xs leading-tight focus:outline-none",
                        placeholder: "Masukan no. telp driver",
                        type: "text"
                      }, null, 544), [
                        [_vModelText, _ctx.driver.phone]
                      ]),
                      _hoisted_19
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.addLicensePlate)
                ? (_openBlock(), _createBlock("div", _hoisted_20, [
                    _hoisted_21,
                    _withDirectives(_createVNode("input", {
                      onInput: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.filterInputLicensePlate && _ctx.filterInputLicensePlate(...args))),
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.licensePlate = $event)),
                      class: "text-gray-lp-500 w-8/12 p-1.5 bg-white border border-gray-lp-400 rounded shadow-xs leading-tight focus:outline-none",
                      placeholder: "Masukan No. seri kendaraan",
                      type: "text"
                    }, null, 544), [
                      [_vModelText, _ctx.licensePlate]
                    ]),
                    _createVNode("div", _hoisted_22, [
                      _createVNode("img", {
                        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.clearLicensePlateForm && _ctx.clearLicensePlateForm(...args))),
                        class: "cursor-pointer",
                        style: {"height":"20px","width":"20px"},
                        src: _imports_1,
                        alt: "x"
                      }),
                      _createVNode("img", {
                        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.submitLicensePlate && _ctx.submitLicensePlate(...args))),
                        class: "cursor-pointer",
                        style: {"height":"20px","width":"20px"},
                        src: _imports_2,
                        alt: "ok"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, _ctx.openPlus]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.addAccountNumber)
        ? (_openBlock(), _createBlock("div", _hoisted_23, [
            (_ctx.dataOptions.length === 0)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleOpenEditBeneficiaryAccount && _ctx.handleOpenEditBeneficiaryAccount(...args))),
                  style: {"border-color":"#d4d5d8"},
                  class: "border rounded-lg py-2 px-3 text-black-lp-300 cursor-pointer focus:outline-none"
                }, [
                  _hoisted_24
                ]))
              : (_openBlock(), _createBlock("button", {
                  key: 1,
                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.handleOpenEditBeneficiaryAccount && _ctx.handleOpenEditBeneficiaryAccount(...args))),
                  style: {"border-color":"#d4d5d8"},
                  class: "border rounded-lg py-2 px-3 text-black-lp-300 cursor-pointer focus:outline-none"
                }, [
                  _hoisted_25
                ]))
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "footer-select", {}, undefined, true)
    ], 512), [
      [_vShow, _ctx.isOpenMenu && !_ctx.isDisabled]
    ]),
    (_ctx.dataOptions.length === 0 && !_ctx.isShowErrorMessage && _ctx.filterSearch)
      ? (_openBlock(), _createBlock("p", _hoisted_26, " Data tidak ditemukan "))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", {
      class: 
        !!_ctx.errorCaption
          ? 'text-red-lp-100 text-12px xxl:text-14px pl-1 py-2 flex gap-x-2'
          : ''
      
    }, [
      (!!_ctx.errorCaption)
        ? (_openBlock(), _createBlock("img", _hoisted_27))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_ctx.errorCaption), 1)
    ], 2), [
      [_vShow, _ctx.isShowErrorIndicator]
    ]),
    (_ctx.isError)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 1,
          onCancel: _ctx.handleErrorClose,
          errorType: _ctx.errorCause,
          modal: ""
        }, null, 8, ["onCancel", "errorType"]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_click_outside, 
      () => {
        if (_ctx.isChevron) {
          _ctx.$refs.selectSearch.focus();
          _ctx.isChevron = false;
        } else if (_ctx.isOpenMenu) {
          _ctx.closeSelect();
        }
      }
    ]
  ])
})